import {
	IGetCustomerInfo,
	TArgumentsForGetCustomersShort,
	IGetCustomersShort,
	ICreateCustomer,
	IUpdateCustomer,
	IGetPaginatedCustomers,
	ICustomers,
	IGetCustomerLocalizationInfo,
	ICreateCustomerLocalization,
	IUpdateCustomerLocalization,
	IGetCustomerLanguages,
	IGetCustomerStylesInfo,
	IUpdateCustomerStyles,
	IGetPaginatedCustomerSoftwareUpdates,
	IGetLatestSoftwareUpdateInfo,
	IPushNotification,
	ISoftwareUpdates,
	IGetCustomerBPA,
	IUpdateCustomerBPA,
	IGetBPAShort,
} from 'types';
import { AxiosResponse } from 'axios';
import { request } from '../index';

const serviceGetCustomerInfo = (customerID: string): Promise<IGetCustomerInfo> => {
	return request({ typeOfRequest: 'getWithToken', url: `/api/Customers/${customerID}` });
};

const serviceGetCustomersShort = (data: TArgumentsForGetCustomersShort): Promise<IGetCustomersShort> => {
	return request({
		typeOfRequest: 'getWithToken',
		url: `/api/Customers/short
		${data?.countryId ? '?countryId=' + data.countryId : ''}
		${data?.cityId ? '&cityId=' + data.cityId : ''}`,
	});
};

const serviceCreateCustomer = (data: ICreateCustomer): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/Customers`, data });
};

const serviceUpdateCustomer = (data: IUpdateCustomer): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'putWithToken', url: `/api/Customers/${data.id}`, data });
};

const serviceGetPaginatedCustomers = (args: IGetPaginatedCustomers): Promise<AxiosResponse<ICustomers>> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/Customers/filtered`, data: args });
};

const serviceDeleteCustomer = (customerID: string): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'deleteWithTokenAndWithParameterInUrlLine', url: `/api/Customers/${customerID}` });
};

const serviceArchiveCustomer = (customerID: string): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/Customers/${customerID}/archive` });
};

const serviceRestoreCustomer = (customerID: string): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/Customers/${customerID}/restore` });
};

const serviceGetCustomerLocalizationInfo = (customerID: string): Promise<IGetCustomerLocalizationInfo> => {
	return request({ typeOfRequest: 'getWithToken', url: `/api/CustomerLocalizations/${customerID}` });
};

const serviceCreateCustomerLocalization = (data: ICreateCustomerLocalization): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/CustomerLocalizations`, data });
};

const serviceUpdateCustomerLocalization = (data: IUpdateCustomerLocalization): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'putWithToken', url: `/api/CustomerLocalizations`, data });
};

const serviceGetCustomerLanguages = (customerID: string): Promise<IGetCustomerLanguages> => {
	return request({ typeOfRequest: 'getWithToken', url: `/api/Customers/${customerID}/languages` });
};

const serviceGetCustomerStylesInfo = (customerID: string): Promise<IGetCustomerStylesInfo> => {
	return request({ typeOfRequest: 'getWithToken', url: `/api/CustomerStyles/${customerID}` });
};

const serviceUpdateCustomerStylesInfo = (data: IUpdateCustomerStyles): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'putWithToken', url: `/api/CustomerStyles/${data.ownerId}`, data });
};

const serviceGetLatestCustomerSoftwareUpdatesData = (customerID: string): Promise<IGetLatestSoftwareUpdateInfo> => {
	return request({ typeOfRequest: 'getWithToken', url: `/api/customers/${customerID}/software/audits/latest` });
};

const servicePushCustomerNotification = (customerID: string, data: IPushNotification): Promise<AxiosResponse<void>> => {
	return request({
		typeOfRequest: 'postWithToken',
		url: `/api/v1/customers/${customerID}/push-notifications:register`,
		data,
	});
};

const serviceGetPaginatedCustomerSoftwareUpdates = (
	args: IGetPaginatedCustomerSoftwareUpdates,
): Promise<AxiosResponse<ISoftwareUpdates>> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/customers/software/audits/filtered`, data: args });
};

const serviceGetCustomerBPA = (customerID: string): Promise<IGetCustomerBPA> => {
	return request({ typeOfRequest: 'getWithToken', url: `/api/BpaSets/customers/${customerID}` });
};

const serviceUpdateCustomerBPA = (data: IUpdateCustomerBPA): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'putWithToken', url: `/api/BpaSets/customers/${data.customerId}`, data });
};

const serviceGetCustomerBPAShort = (customerID: string): Promise<IGetBPAShort> => {
	return request({ typeOfRequest: 'getWithToken', url: `/api/BpaSets/customers/${customerID}/short` });
};

export {
	serviceGetCustomerInfo,
	serviceGetCustomersShort,
	serviceCreateCustomer,
	serviceUpdateCustomer,
	serviceGetPaginatedCustomers,
	serviceDeleteCustomer,
	serviceArchiveCustomer,
	serviceRestoreCustomer,
	serviceGetCustomerLocalizationInfo,
	serviceCreateCustomerLocalization,
	serviceUpdateCustomerLocalization,
	serviceGetCustomerLanguages,
	serviceGetCustomerStylesInfo,
	serviceUpdateCustomerStylesInfo,
	serviceGetLatestCustomerSoftwareUpdatesData,
	servicePushCustomerNotification,
	serviceGetPaginatedCustomerSoftwareUpdates,
	serviceGetCustomerBPA,
	serviceUpdateCustomerBPA,
	serviceGetCustomerBPAShort,
};
